<script>
  import { ImageItem, SearchInput } from '@client/pages/brandkit/components';

  import { images, search, setSearch } from '@client/stores/background-image';

  import { debounce } from '@common/utils/debounce';

  /** @type {boolean} */
  export let active = false;
  /** @type {(image: string, avgColor: string) => void} */
  export let onSelect = () => {};

  /** @type {HTMLInputElement} */
  let searchInput;

  $: if (active && searchInput) searchInput.focus();

  const onSearch = debounce((e) => setSearch(/** @type {HTMLInputElement} */ (e.target).value), 500);
</script>

<header class="sticky-top bg-white p-3 pb-2">
  <SearchInput value={$search} on:input={onSearch} bind:inner={searchInput} />
</header>

<div class="list-group list-group-flush px-3">
  {#each $images as image}
    {#key image.thumbnail}
      <ImageItem
        name={image.alt || '-'}
        description={image.photographer}
        on:click={(e) => onSelect(image.full, image.average)}
      >
        <img src={image.thumbnail} alt={image.alt} loading="lazy" />
      </ImageItem>
    {/key}
  {/each}
</div>

<style lang="scss">
  .list-group {
    overflow-y: auto;
  }

  img {
    max-width: 5rem;
  }
</style>
